export default __webpack_public_path__ + "static/media/58.45f93ae3.png";